import * as Petrus from '@ackee/petrus';
import { put, take, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { routingSelector } from '@ackee/chris';
import { logoutRequest } from '@ackee/petrus';
import { actions as formActions, takeFormSubmission } from 'modules/form';
import { createUIErrorMessage } from 'modules/errors';
import config from 'config';
import * as Log from 'config/loglevel';
import { LoginFormValues } from '../../types';
import { forms } from '../../config';
const getAuthState = (state) => state.petrus.entities;

function* redirectBack(token, userId, email) {
    const location = yield select(routingSelector);
    const search: string = window.location.search;
    const match = /[?&]redirectUrl=([^&]+)/.exec(search);
    const redirectUrl = match ? decodeURIComponent(match[1]) : null;
    if (redirectUrl) {
        // if there is a question mark already in redirectUrl use & instead
        const separator = redirectUrl.includes('?') ? '&' : '?';
        window.location.href = `${redirectUrl}${separator}token=${token}&userId=${userId}&email=${email}`;

        yield put(logoutRequest());
    } else {
        // Fallback to React Router navigation (SPA-friendly)
        const returnLocation = location.state?.from
            ? {
                pathname: location.state.from.pathname,
                search: location.state.from.search,
            }
            : {
                pathname: config.routes.home,
            };

        yield put(push(returnLocation));
    }


}

function* handleLoginForm(action: formActions.types.SubmitFormAction<LoginFormValues>) {
    yield put(Petrus.loginRequest(action.payload));

    const result = yield take([Petrus.LOGIN_SUCCESS, Petrus.LOGIN_FAILURE]);

    if (result.type === Petrus.LOGIN_SUCCESS) {
        const authdata = yield select(getAuthState);
        const token = authdata?.tokens?.accessToken?.token
        const userId = authdata?.user.customUserId
        const email = authdata?.user.email
        yield put(formActions.submitFormSuccess(forms.login));
        yield redirectBack(token, userId, email);
    } else {
        Log.error(result.error);

        const uiError = createUIErrorMessage(result.error);
        yield put(formActions.submitFormFailure(forms.login, uiError));
    }
}

function* redirectOnTokenAvailable() {
    const search: string = window.location.search;
    const match = /[?&]redirectUrl=([^&]+)/.exec(search);
    if (!match) return;

    yield take(Petrus.ACCESS_TOKEN_AVAILABLE);

    const authdata = yield select(getAuthState);
    const token = authdata?.tokens?.accessToken?.token;
    const userId = authdata?.user?.customUserId;
    const email = authdata?.user?.email;
    if (!token) return;

    const redirectUrl = decodeURIComponent(match[1]);
    const separator = redirectUrl.includes('?') ? '&' : '?';
    window.location.href = `${redirectUrl}${separator}token=${token}&userId=${userId}&email=${email}`;
    yield put(logoutRequest());
}

export { redirectOnTokenAvailable };

export default function* loginForm() {
    yield takeFormSubmission(forms.login, handleLoginForm);
}
